import React from 'react';
import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { PageErrorFallback } from './PageErrorFallback';

export const PageErrorBoundary: React.FC<PropsWithChildren> = ({ children }) => {
  return <ErrorBoundary FallbackComponent={PageErrorFallback}>{children}</ErrorBoundary>;
};
